import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { ConfigContext } from './ConfigContext';
import DeloitteBlackLOGO from '../../public/DeloitteBlackLOGO.svg';
export function LogoAndProductName(_ref) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$application = _ref.application, application = _ref$application === void 0 ? '' : _ref$application;
    var navigate = useNavigate();
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    // Helper function to determine what content should be shown
    var shouldShowDeloitteLogo = configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.show_deloitte_logo;
    var shouldShowCustomLogo = (configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.show_logo) && (configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.header_logo_image);
    var shouldShowWorkspaceName = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.show_workspace_name;
    var shouldShowApplication = pathname !== '/' && pathname !== '/settings' && pathname !== '/productSelection' && pathname !== '/terms-of-use' && application;
    // Function to navigate to product selection
    var handleLogoClick = function handleLogoClick() {
        var _process$env$REACT_AP;
        if (JSON.parse((_process$env$REACT_AP = process.env.REACT_APP_false) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'false')) {
            navigate('/productSelection');
        }
    };
    // Build array of elements to render
    var elements = [];
    // Add Deloitte logo
    if (shouldShowDeloitteLogo) {
        elements.push(/*#__PURE__*/ React.createElement(Box, {
            key: "deloitte-logo",
            component: "img",
            src: DeloitteBlackLOGO,
            alt: "Deloitte",
            sx: {
                height: 20,
                width: 100,
                display: 'flex',
                alignItems: 'center',
                objectFit: 'contain',
                '&:hover': {
                    cursor: 'pointer'
                }
            },
            onClick: handleLogoClick,
            title: "Go to homepage"
        }));
    }
    // Add custom logo
    if (shouldShowCustomLogo) {
        var _configState$settings5;
        elements.push(/*#__PURE__*/ React.createElement(Box, {
            key: "custom-logo",
            component: "div",
            dangerouslySetInnerHTML: {
                __html: configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.header_logo_image
            },
            onClick: handleLogoClick,
            title: "Go to homepage",
            sx: {
                height: 28,
                maxWidth: 120,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& svg': {
                    height: '100% !important',
                    width: 'auto !important',
                    maxHeight: '28px !important',
                    maxWidth: '120px !important',
                    display: 'block',
                    objectFit: 'contain'
                },
                '& img': {
                    height: '100%',
                    width: 'auto',
                    maxHeight: '28px',
                    maxWidth: '120px',
                    objectFit: 'contain'
                },
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }));
    }
    // Add workspace name
    if (shouldShowWorkspaceName) {
        var _configState$settings6, _configState$settings7;
        elements.push(/*#__PURE__*/ React.createElement(Typography, {
            key: "workspace-name",
            variant: "body1",
            sx: {
                color: "".concat(configState === null || configState === void 0 || (_configState$settings6 = configState.settings) === null || _configState$settings6 === void 0 ? void 0 : _configState$settings6.workspace_name_color),
                fontFamily: 'Open Sans',
                fontSize: 27,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '70%',
                letterSpacing: '-0.54px'
            }
        }, configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.workspace_name));
    }
    // Add application name
    if (shouldShowApplication) {
        var _configState$settings8;
        elements.push(/*#__PURE__*/ React.createElement(Typography, {
            key: "application-name",
            variant: "body1",
            sx: {
                color: "".concat(configState === null || configState === void 0 || (_configState$settings8 = configState.settings) === null || _configState$settings8 === void 0 ? void 0 : _configState$settings8.workspace_name_color),
                fontFamily: 'Open Sans',
                fontSize: 27,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '70%',
                letterSpacing: '-0.54px'
            }
        }, application));
    }
    // Add dividers between elements (only if there are multiple elements)
    var elementsWithDividers = [];
    elements.forEach(function (element, index) {
        elementsWithDividers.push(element);
        // Add divider after each element except the last one
        if (index < elements.length - 1) {
            var _configState$settings9;
            elementsWithDividers.push(/*#__PURE__*/ React.createElement(Divider, {
                key: "divider-".concat(index),
                orientation: "vertical",
                sx: {
                    border: "1px solid ".concat(configState === null || configState === void 0 || (_configState$settings9 = configState.settings) === null || _configState$settings9 === void 0 ? void 0 : _configState$settings9.workspace_name_color),
                    height: '28px'
                },
                flexItem: true
            }));
        }
    });
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 2,
        sx: {
            alignItems: 'center'
        }
    }, elementsWithDividers));
}
